import React, { Component } from "react";
import ReactGA from "react-ga";
import BannerImg from "../../assets/images/banner/microsoft-technologies.png";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

class MicrosoftTechnologies extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>Microsoft Technologies & Enterprise Platform Engineering Heritage | Avani Cimcon</title>
          <meta
            name="keywords"
            content="Microsoft technologies, Microsoft .net technologies, Microsoft technologies development, Microsoft .Net development, .NET application development, ASP.Net, ASP, XML, HTML, XHTML, XSL XML-FO, WAP, VB Script, IIS, VB.Net, C#, Visual C++, Visual Basic, enterprise integration, legacy modernization, platform engineering, custom software development, .Net outsourcing, Microsoft business solutions, SharePoint, MSMQ"
          />
          <meta
            name="description"
            content="Avani Cimcon has deep Microsoft platform experience across .NET, ASP.Net, C#, VB.Net, IIS, XML, and enterprise integration. That heritage now supports modernization, migration, and AI-assisted engineering."
          />
          <link rel="canonical" href="https://www.avanicimcon.com/microsoft-technologies" />
        </Helmet>

        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">Microsoft Technologies</h1>
            <h5>Platform experience archive</h5>
          </div>
          <div className="page-banner-img" style={{ backgroundImage: `url("${BannerImg}")` }}></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify">
              <p className="font-weight-bold text-primary">
                Avani Cimcon has been developing complex B2B and B2C applications on Microsoft
                technologies for decades. That foundation now strengthens legacy modernization,
                platform migration, enterprise integration, and AI-assisted delivery on the
                Microsoft stack.
              </p>
              <p>
                Avani Cimcon Technologies (ACT) is one of the pioneers in developing applications in
                Microsoft technologies. We have internally developed Microsoft-based frameworks that
                allow teams to jump-start enterprise development quickly. This experience reflects
                years of investment in training, architecture, and delivery on industry standard
                development platforms.
              </p>

              <p>
                Having a broad range of technical expertise, ACT helps clients choose the right set
                of technologies to deliver maximum value within the framework of their particular
                modernization, integration, and software delivery programs.
              </p>
              <h5 className="text-primary mt-4 mb-3">
                Our expertise in development in Microsoft Technologies is follows:
              </h5>

              <table className="table table-bordered">
                <thead>
                  <tr className="bg-light">
                    <th colSpan="2">Microsoft Technology Expertise</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td className="bg-light font-weight-bold">Languages</td>
                    <td>VB.Net, C#, Visual C++ (ATL), C, Visual Basic...</td>
                  </tr>

                  <tr>
                    <td className="bg-light font-weight-bold">Web Technologies</td>
                    <td>ASP.Net, ASP, XML, HTML, XHTML, XSL XML-FO, WAP, VB Script, IIS</td>
                  </tr>

                  <tr>
                    <td className="bg-light font-weight-bold">Database</td>
                    <td>MS SQL Server 7.0/2000/2005, MS SQL Reporting Services and MS Access</td>
                  </tr>

                  <tr>
                    <td className="bg-light font-weight-bold">Middle Tier</td>
                    <td>COM+, Microsoft Commerce Server</td>
                  </tr>

                  <tr>
                    <td className="bg-light font-weight-bold">Messaging</td>
                    <td>MS Messaging Queue (MSMQ 3.0)</td>
                  </tr>

                  <tr>
                    <td className="bg-light font-weight-bold">Communication</td>
                    <td>.NET Remoting, Web Services (SOAP/HTTP)</td>
                  </tr>

                  <tr>
                    <td className="bg-light font-weight-bold">Testing</td>
                    <td>MS Application Test Center, MS web application stress tool</td>
                  </tr>

                  <tr>
                    <td className="bg-light font-weight-bold">Documentation</td>
                    <td>NDoc, VBX commenter, ASP C# API Documenting tools</td>
                  </tr>

                  <tr>
                    <td className="bg-light font-weight-bold">Other Products</td>
                    <td>
                      MS Project, MS Visio Architect and MS-Office 2003MS Share Point Portal Server,
                      MS InfoPath 2003, MS Exchange Server
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="mt-4 p-4 bg-light border rounded">
                <h5 className="text-primary mb-3">Why Microsoft ecosystem depth still matters</h5>
                <ul className="mb-0">
                  <li className="mb-2">
                    <Link to="/it-consulting-services">Modernize enterprise systems without abandoning the Microsoft stack</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/dxchange">Use Microsoft integration depth to support DXchange and data exchange</Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/quality-assurance">Pair platform knowledge with safer delivery and release confidence</Link>
                  </li>
                  <li>
                    <Link to="/contact-us">Talk to us about Microsoft-based modernization programs</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default MicrosoftTechnologies;
